import { FC } from "react";

import { Theme } from "apps/website/maps/Theme.map";
import { Breakpoint } from "apps/website/maps/Breakpoint.map";
import { IconSvg } from "apps/website/components/base/Icon/Icon.map";
import Text from "apps/website/components/base/Text/Text";
import Icon from "apps/website/components/base/Icon/Icon";
import cx from "apps/website/utils/misc/cx";

import { AccordionType, TEXT_MAP } from "../Accordion.map";
import {
  getButtonClasses,
  getButtonTextClasses,
  getHorizontalRuleClasses,
  getIconRotationClasses,
  getPreviewOpacityRotationClasses,
} from "../Accordion.utils";

interface IAccordionButton {
  testId?: string;
  headerId?: string;
  bodyId?: string;
  type: AccordionType;
  theme: Theme;
  displayTitle: string;
  icon: IconSvg;
  isAccordionOpen: boolean;
  isPrimingScreenTest: boolean;
  isActiveBreakpointBelow: (breakpoint: Breakpoint) => boolean;
  PreviewContent?: React.ReactElement;
  onToggle: () => void;
}

const AccordionButton: FC<IAccordionButton> = ({
  testId,
  headerId,
  bodyId,
  type,
  theme,
  displayTitle,
  icon,
  isAccordionOpen,
  isPrimingScreenTest,
  isActiveBreakpointBelow,
  PreviewContent,
  onToggle,
}) => {
  const isPreviewType = type === "preview";
  const showDefaultIcon = [ "default", "full-border" ].includes(type) || (type === "footer" && isActiveBreakpointBelow("lg"));
  const showHorizontalRuleIcon = [ "horizontal-rule", "underline" ].includes(type);

  return (
    <button
      data-testid={`${testId}-toggle`}
      id={headerId}
      className={cx(`flex items-center w-full py-4 ${getButtonClasses(type, theme)} ${isPrimingScreenTest && "py-0"}`)}
      onClick={onToggle}
      aria-controls={bodyId}
      aria-expanded={isAccordionOpen}
    >
      <Text
        tag="span"
        display={TEXT_MAP[type].display}
        size={TEXT_MAP[type].size}
        align={TEXT_MAP[type].align}
        className={getButtonTextClasses(type)}
      >
        { displayTitle }
        { isPreviewType && (
          <Icon icon="chevronDownHeavy" size="xsmall" className={ `ml-2 transform transition-transform ease-in-out duration-300 ${getIconRotationClasses(isAccordionOpen)}`}/>
        ) }
      </Text>
      { showDefaultIcon && (
        <Icon icon={icon} size="small" />
      ) }
      { showHorizontalRuleIcon && (
        <div className={getHorizontalRuleClasses(type)}>
          <Icon icon="arrowDown" size="xsmall" className={`transition-transform ease-in-out duration-300 ${getIconRotationClasses(isAccordionOpen)}`}/>
        </div>
      ) }
      { isPreviewType && (
        <div className={ `transition-opacity duration-300 ease-in-out ${getPreviewOpacityRotationClasses(!isAccordionOpen)}`}>
          { PreviewContent }
        </div>
      ) }
    </button>
  );
};

export default AccordionButton;
